module.exports = __webpack_public_path__ + "static/media/heart-fill.5a2ce5b0.svg";